module.exports = __webpack_public_path__ + "img/qr.d963b26a.png";